import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { SuccessorFormQuestion } from "./questionTypes";
import { SuccessorFormAnswer } from "./answerTypes";

interface SuccessorFormQuestionProps {
  question: SuccessorFormQuestion;
  value: SuccessorFormAnswer;
  onChange: (questionId: string, value: SuccessorFormAnswer) => void;
}

export function SuccessorFormQuestionComponent({ 
  question, 
  value, 
  onChange 
}: SuccessorFormQuestionProps) {
  const handleFieldChange = (field: string, fieldValue: string) => {
    onChange(question.id, {
      ...value,
      [field]: fieldValue
    });
  };

  return (
    <div className="space-y-6">
      <h2 className="text-xl font-semibold text-left mb-6">{question.title}</h2>
      
      <div className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="space-y-2">
            <Label htmlFor="firstName">First Name</Label>
            <Input
              id="firstName"
              value={value.firstName || ""}
              onChange={(e) => handleFieldChange("firstName", e.target.value)}
              placeholder="Enter first name"
            />
          </div>
          
          <div className="space-y-2">
            <Label htmlFor="lastName">Last Name</Label>
            <Input
              id="lastName"
              value={value.lastName || ""}
              onChange={(e) => handleFieldChange("lastName", e.target.value)}
              placeholder="Enter last name"
            />
          </div>
        </div>
        
        <div className="space-y-2">
          <Label htmlFor="relationship">Relationship to you</Label>
          <Select
            value={value.relationship || ""}
            onValueChange={(fieldValue) => handleFieldChange("relationship", fieldValue)}
          >
            <SelectTrigger>
              <SelectValue placeholder="Select relationship" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="family-member">Family Member</SelectItem>
              <SelectItem value="current-associate">Current Associate</SelectItem>
              <SelectItem value="external-peer">External Peer</SelectItem>
              <SelectItem value="other">Other</SelectItem>
            </SelectContent>
          </Select>
          
          {value.relationship === "other" && (
            <Input
              value={value.relationshipOther || ""}
              onChange={(e) => handleFieldChange("relationshipOther", e.target.value)}
              placeholder="Please specify relationship"
              className="mt-2"
            />
          )}
        </div>
      </div>
    </div>
  );
}